import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import archivableMixin from './archivableMixin'
import jobPartiesMixin from './jobPartiesMixin'
import statusesMixin from './statusesMixin'
import { declineApplicationAsFreelancer } from '@/api/jobs/applications/applications'
import { JobOfferStages } from '@/constants/job/jobOfferStages'
import { JOB_DETAILS_ADMIN_APPLICATIONS, MY_JOBS } from '@/constants/routes'
import Button from '@/models-ts/ui/Button'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [archivableMixin, jobPartiesMixin, archivableMixin, statusesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
    }),
    hasRetractApplicationByFreelancer() {
      return this.isWorker && !this.isArchived && !this.isStarted && this.application.offer?.stage !== JobOfferStages.ACCEPTED_BY_CUSTOMER
    },
    hasDeclineApplicationByCustomer() {
      return this.isEmployer && !this.isArchived && !this.application?.wasStarted && !this.isMetaArchived
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    async declineApplicationByCustomer() {
      await this.setArchivedMeta(true)

      googleAnalyticsV2.send({
        event: 'response-to-job',
        'event-content': 'customer-button-click-decline',
        job_id: this.application.job.id,
      })

      this.$router.push({
        name: JOB_DETAILS_ADMIN_APPLICATIONS,
        params: { id: this.application.job.id, slug: this.application.job.slug },
      })
    },
    declineApplicationByFreelancer() {
      this.openModal({
        component: 'lx-composite-modal-new',
        props: {
          title: 'Retract application?',
          text: `This application will be removed from applications list.`,
          buttons: [
            new Button({
              text: 'Cancel',
              classes: 'lx-transparent-blue-btn',
            }),
            new Button({
              text: 'Proceed',
              classes: 'lx-blue-btn',
              onClick: async () => {
                await declineApplicationAsFreelancer(this.application.id)
                this.$router.push({ name: MY_JOBS })
              },
            }),
          ],
        },
      })
    },
  },
})
